import { useForm, type DefaultValues } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import type { z } from 'zod';

export function useFormWithValidation<T extends z.ZodTypeAny>(schema: T, defaultValues?: DefaultValues<z.infer<T>>) {
  type FormData = z.infer<T>;

  return useForm<FormData>({
    resolver: zodResolver(schema),
    defaultValues,
    mode: 'onChange'
  });
}
